import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { LoginPage } from '@/features/auth/LoginPage';
import { ProtectedRoute } from '@/features/auth/ProtectedRoute';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { POSPage } from '@/features/pos/POSPage';
import { DatahubPage } from '@/features/datahub/DatahubPage';
import { QuotationsPage } from '@/features/quotations/QuotationsPage';
import { QuotationBuilderPage } from '@/features/quotations/QuotationBuilderPage';
import { PublicQuotationPage } from '@/features/quotations/PublicQuotationPage';
import { CRMPage } from '@/features/crm/CRMPage';
import { CustomerDetailPage } from '@/features/crm/CustomerDetailPage';
import { StoresPage } from '@/features/stores/StoresPage';
import { EmployeesPage } from '@/features/employees/EmployeesPage';
import { SettingsPage } from '@/features/settings/SettingsPage';
import { SupportPage } from '@/features/support/SupportPage';
import { IntegrationsPage } from '@/features/integrations/IntegrationsPage';
import { OrderReceiptPage } from '@/features/pos/OrderReceiptPage';
import { HandmadeBillsPage } from '@/features/bills/HandmadeBillsPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/q/:token', element: <PublicQuotationPage /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: '/', element: <DashboardPage /> },
          { path: '/pos', element: <POSPage /> },
          { path: '/pos/orders/:orderId', element: <OrderReceiptPage /> },
          { path: '/datahub', element: <DatahubPage /> },
          { path: '/quotations', element: <QuotationsPage /> },
          { path: '/quotations/new', element: <QuotationBuilderPage /> },
          { path: '/quotations/:quotationId', element: <QuotationBuilderPage /> },
          { path: '/crm', element: <CRMPage /> },
          { path: '/crm/:customerId', element: <CustomerDetailPage /> },
          { path: '/support', element: <SupportPage /> },
          { path: '/integrations', element: <IntegrationsPage /> },
          { path: '/bills', element: <HandmadeBillsPage /> },
          {
            element: <ProtectedRoute allow={['owner']} />,
            children: [
              { path: '/stores', element: <StoresPage /> },
              { path: '/settings', element: <SettingsPage /> },
            ],
          },
          {
            element: <ProtectedRoute allow={['owner', 'manager']} />,
            children: [{ path: '/employees', element: <EmployeesPage /> }],
          },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
